import React, { useState, useEffect } from 'react';
import './Testimonials.css';
import starIcon from '../star.png';
import semiIcon from '../semi.png';
import av1 from '../av1.png';
import av2 from '../av2.png';
import av3 from '../av3.png';
import av4 from '../av4.png';

const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      id: 1,
      quote: "Sri Veda Gurukulam preserves authentic Vedic traditions while instilling discipline, values, and spiritual clarity in students.",
      name: "Suresh & Lakshmi Rao",
      location: "Hyderabad",
      avatar: av1
    },
    {
      id: 2,
      quote: "The Gurukul shaped my character through discipline, devotion, and direct learning under experienced and dedicated Acharyas",
      name: "Anirudh Sharma",
      location: "Former Student",
      avatar: av2
    },
    {
      id: 3,
      quote: "Every ritual was performed with purity, precision, and devotion, creating peace and spiritual positivity for us.",
      name: "Ramesh Kumar",
      location: "Ramesh Kumar Family",
      avatar: av3
    },
    {
      id: 4,
      quote: "Sri Veda Gurukulam stands as a beacon of Vedic knowledge, discipline, and Dharmic values.",
      name: "Dr. Mahesh Iyer",
      location: "Physician",
      avatar: av4
    }
  ];

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const renderStars = () => {
    return (
      <div className="stars-rating" style={{
        display: 'flex',
        gap: '4px',
        margin: '15px 0 20px 0',
        justifyContent: 'flex-start',
        alignItems: 'center',
        visibility: 'visible',
        opacity: 1
      }}>
        {Array(5).fill(0).map((_, index) => (
          <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
            <img 
              src={starIcon} 
              alt="star" 
              className="star-icon"
              style={{
                width: '20px',
                height: '20px',
                objectFit: 'contain',
                display: 'inline-block',
                visibility: 'visible',
                opacity: 1,
                background: 'none',
                border: 'none'
              }}
              onError={(e) => {
                // Fallback to text star if image fails to load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'inline-block';
              }}
            />
            <span style={{
              display: 'none',
              color: '#FFD700',
              fontSize: '20px',
              lineHeight: '1'
            }}>★</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="testimonials-header">
          <div className="testimonials-line"></div>
          <h2 className="testimonials-title">Testimonials</h2>
          <p className="testimonials-subtitle">
            Hear from students, families, and devotees who have experienced the teachings and services of Sri Veda Gurukulam.
          </p>
        </div>
        
        <div className="simple-carousel">
          {/* Navigation Buttons */}
          <button className="nav-btn prev-btn" onClick={prevSlide}>
            &#8249;
          </button>
          
          <button className="nav-btn next-btn" onClick={nextSlide}>
            &#8250;
          </button>

          {/* Current Testimonial */}
          <div className="testimonial-display">
            <div className="quote-section">
              <img src={semiIcon} alt="Quote" className="quote-image" style={{
                width: '40px',
                height: '40px',
                marginBottom: '15px',
                display: 'block',
                visibility: 'visible',
                opacity: 1
              }} />
              
              <div style={{ marginBottom: '20px' }}>
                {renderStars()}
              </div>
              
              <div className="quote-text" style={{
                fontFamily: 'Be Vietnam Pro, sans-serif',
                fontSize: '18px',
                fontWeight: '400',
                lineHeight: '1.6',
                color: '#333',
                margin: '20px 0',
                textAlign: 'left',
                display: 'block',
                visibility: 'visible',
                opacity: 1
              }}>
                {testimonials[currentSlide].quote}
              </div>
            </div>
            
            <div className="author-section">
              <img 
                src={testimonials[currentSlide].avatar} 
                alt={testimonials[currentSlide].name}
                className="author-image"
              />
              <div className="author-details">
                <div className="author-name-text">
                  {testimonials[currentSlide].name}
                </div>
                <div className="author-location-text">
                  {testimonials[currentSlide].location}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;